import { createSelector } from 'reselect'

export const getCartCurrentHistoryItemLoading = createSelector(
  (state) => state && state.cart && state.cart.history && state.cart.history.currentItemLoading,
  isLoading => isLoading
)
